<app-admin-list-page [title]="'Schools' | translate">

  <a slot="actions" class="btn btn-primary" routerLink="/admin/externalpage/School">
    {{'Add new' | translate}}
  </a>

  <app-table [config]="configTable" (buttonEvent)="handleButtonEvent($event)"></app-table>

</app-admin-list-page>
